import { CarSearchOutlineIcon } from './CarSearchOutlineIcon';

/**
 * author: tetzla
 * id B64ACFFE-836E-4F68-8D1B-3F6FCC263602
 * name car-search-outline
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/car-search-outline.svg
 * tags
 * - Automotive 
 */
export const CarFindOutlineIcon = CarSearchOutlineIcon;
export default CarFindOutlineIcon